import { type DietaryRestriction } from '@sg/graphql-schema';
import { type DietaryPreferencesTypes } from '@sg/shared-fe/features/menu';

/**
 * Converts the dietary preferences object to a list of filtered restrictions.
 */
export function getDietaryPreferencesList(
  dietaryPreferences: DietaryPreferencesTypes,
): DietaryRestriction[] {
  const preferencesKeys = Object.keys(dietaryPreferences) as DietaryRestriction[]; // prettier-ignore

  return preferencesKeys.filter((restriction) =>
    Boolean(dietaryPreferences[restriction]),
  );
}
